<template>
    <v-select
            v-model="lang"
            :label="$t('field.lang')"
            :items="languageItems"
            item-text="name"
            item-value="code"
            @input="changed()"
    ></v-select>
</template>

<script>
    export default {
        name: "LanguageInput",
        props: {
            value: {
                default: '',
                type: String,
            }
        },
        data () {
            return {
                lang: null,
            }
        },
        methods: {
            changed () {
                this.$emit('input', this.lang);
            }
        },
        watch: {
            // lang () {
            //     this.$emit('input', this.lang);
            // },
            value () {
                this.lang = this.value;
            },
        },
        computed: {
            languageItems () {
                return [
                    { name: 'English', code: 'EN' },
                    { name: 'عربي', code: 'AR' },
                    { name: 'עברי', code: 'HE' },
                ]
            },
        },
        mounted () {
            this.lang = this.value;
        }

    }
</script>

<style scoped>

</style>
